<template>
  <div>
    <styled-button
      type="submit"
      :width="width"
      :height="height"
      :isDisabled="isDisabled"
      :disabled="isDisabled"
      ><img :src="imagePath" alt="" class="icon" v-if="iconName" /><span>{{
        label
      }}</span></styled-button
    >
  </div>
</template>

<script>
import { StyledButton } from "./redButton.styles";

export default {
  name: "RedButton",
  data() {
    return {
      isDisabled: false,
    };
  },
  components: {
    StyledButton,
  },
  props: {
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    iconName: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.isDisabled = this.disable;
  },

  computed: {
    imagePath() {
      return require(`../../../assets/${this.iconName}.png`);
    },
  },

  watch: {
    disable(newValue) {
      this.isDisabled = newValue;
    },
  },
};
</script>

<style scoped>
.icon {
  width: 14px;
  height: auto;
  margin-right: 6px;
}

span {
  display: inline-block;
  margin-left: 5px;
}
</style>
